import { ValidationRule } from '@/mixins/validation/validator';

export const checkboxRequired: ValidationRule = value => {
	const isValid = value === true;

	return isValid || 'Checkbox is required';
};
